import { createSelector } from 'reselect'
import { getTrackListItems } from '../../components/tracklist/trackListSelectors'

const getLocalState = state => state.pages.album || {}

export const getPochette = state => (getLocalState(state).image || {}).large
export const getTitle = state => getLocalState(state).title
export const getArtist = state => getLocalState(state).artist || {}
export const getNbPistes = state => getLocalState(state).tracks_count
export const isHires = state => getLocalState(state).hires
export const getDuree = state => getLocalState(state).duration
export const isQobuzissime = state => getLocalState(state).isQobuzissime
export const getDescription = state => getLocalState(state).description
export const getOrderUrl = state => getLocalState(state).orderUrl

// On n'affiche l'artiste sur chaque track s'il est différent de l'artiste de l'album
export const shouldDisplayArtist = createSelector(
	getArtist,
	getTrackListItems,
	(artist, tracks) => {
		console.log(artist, tracks)
		const tracksFiltered = tracks.filter(track => artist && track.performer && track.performer.id !== artist.id)

		return tracksFiltered.length > 0
	}
)



// WEBPACK FOOTER //
// ./src/pages/album/albumSelectors.js